import { Flex, FormattedRelativeTime, Stack, Text, TextLabel } from '@customerio/pluma-components/react';
import { StatusBadge } from '@/features/pipelines/components';
import { computeStatus, destinationModeLabel } from '@/features/pipelines/utils';
import type { SourceResult, DestinationResult } from '@/services/auth/types';
import type { IntegrationCatalog } from '../utils/integration-catalog';

type InfoRowProps = { label: string; children: React.ReactNode };

function InfoRow({ label, children }: InfoRowProps) {
  return (
    <Flex direction="column" gap="025">
      <TextLabel>{label}</TextLabel>
      <Text size="sm">{children}</Text>
    </Flex>
  );
}

type IntegrationPreviewProps = { result: SourceResult | DestinationResult; catalog: IntegrationCatalog };

export function IntegrationPreview({ result, catalog }: IntegrationPreviewProps) {
  const { enabled, created_at, last_activity } = result.other;
  const lastActivitySeconds = last_activity != null ? last_activity / 1000 : 0;
  const computedStatus = computeStatus(enabled, lastActivitySeconds);
  const catalogEntry = catalog.get(result.other.type);
  const category = catalogEntry?.category;
  const mode = catalogEntry?.mode;

  return (
    <Stack gap="200">
      {category != null ? <InfoRow label="Category">{category}</InfoRow> : null}

      {result.kind === 'destination' && mode != null ? (
        <InfoRow label="Connection Mode">{destinationModeLabel(mode)}</InfoRow>
      ) : null}

      <InfoRow label="Status">
        <StatusBadge status={computedStatus} />
      </InfoRow>

      <InfoRow label="Data last received">
        {last_activity != null ? <FormattedRelativeTime date={last_activity} withTooltip /> : '—'}
      </InfoRow>

      {created_at != null ? (
        <InfoRow label="Created">
          <FormattedRelativeTime date={created_at} withTooltip />
        </InfoRow>
      ) : null}
    </Stack>
  );
}
